import { apiClient } from '@/shared/api/http-client';

import type {
    ClientBillingSettings,
    ClientBillingSettingsPatchOf,
    ClientBillingSettingsType,
} from '../model/client-billing-settings.types';

export const clientBillingSettingsApi = {
    getByType: async <T extends ClientBillingSettingsType>(
        type: T,
        signal?: AbortSignal,
    ): Promise<Extract<ClientBillingSettings, { type: T }>> => {
        return apiClient.get(`/client-billing-settings/${type}`, signal);
    },
    updateByType: async <T extends ClientBillingSettingsType>(
        type: T,
        patch: ClientBillingSettingsPatchOf<T>,
        signal?: AbortSignal,
    ): Promise<void> => {
        return apiClient.patch(`/client-billing-settings/${type}`, { value: patch }, signal);
    },
};
